import React, { useState } from "react";
import type { RdMetrics, TenureBand } from "../../../../../shared/metrics";
import {
  METRIC_SECTIONS,
  dataAnchor,
  type FunctionalFormLink,
} from "../../../lib/metrics-display";
import { MetricsPageHead } from "./metrics-page-head";
import { PeriodTable } from "./period-table";
import { SessionFunnelPanel } from "./session-funnel-panel";

/**
 * The full Metrics page body for one RD's detail metrics; band selection lives
 * here. `functionalFormLink` wraps the missing-minimum flag's link, supplied by
 * the route.
 */
export function MetricsContent({
  data,
  functionalFormLink,
}: {
  data: RdMetrics;
  functionalFormLink?: FunctionalFormLink;
}) {
  const [band, setBand] = useState<TenureBand>(data.tenure?.band ?? "90+");
  const anchor = dataAnchor(data.dataThrough);

  return (
    <div className="flex flex-col gap-5">
      <MetricsPageHead
        anchor={anchor}
        sources={Object.values(data.metrics).map((metric) => metric.source)}
      />
      {data.funnel && (
        <SessionFunnelPanel
          funnel={data.funnel}
          tenure={data.tenure}
          band={band}
          onBandChange={setBand}
        />
      )}
      {METRIC_SECTIONS.map((section) => (
        <PeriodTable
          key={section.id}
          section={section}
          metrics={data.metrics}
          anchor={anchor}
          startDate={data.tenure?.startDate}
          functionalFormLink={functionalFormLink}
        />
      ))}
    </div>
  );
}
